import type { SupabaseClient } from '@supabase/supabase-js';
import { getSupabase } from '../supabase';

// Test seam: inject a fake client so the data layer is unit-testable without
// touching the real SDK or network.
let injected: SupabaseClient | null = null;

export function setClient(c: SupabaseClient | null): void {
  injected = c;
}

export function sb(): SupabaseClient | null {
  return injected ?? getSupabase();
}

